//namespace
window.QJTApp = window.QJTApp || { modules: {} };

/**
 * Módulo de montagem da Home do site
 *
 * @module IndexPage
 * @namespace modules.home
 */
QJTApp.modules.Profile = (function($) {
  'use strict';

  /**
   * O nome da Controller. Referência do nome da controller do CI.
   *
   * @private
   * @property controllerName
   * @type String
   */
  var controllerName = 'perfil2';

  /**
   * Pega a url e armazena suas partes em um array
   *
   * @private
   * @property pathArray
   * @type Array
   */
  var pathArray;

  /**
   * O index da parte da url a partir de onde o script deve responder.
   * Corresponde a posição do nome da controller.
   *
   * @private
   * @property basePathIndex
   * @type Number
   */
  var basePathIndex;

  /**
   * O nome do método. A parte da url que corresponde ao método da Controller.
   *
   * @private
   * @property currentMethod
   * @type String
   */
  var currentMethod;

  /**
   * O parâmetro. A parte da url que corresponde ao parâmetro passado ao método.
   *
   * @private
   * @property currentParam
   * @type String
   */
  var currentParam;

  /**
   * Armazena o número que corresponde a um tipo de perfil conforme a base
   * de dados:
   * 0 - Tenista;
   * 1 - CBT;
   * 2 - Federação;
   * 3 - Clube;
   * 4 - Academia;
   * 5 - Universidade;
   * 6 - Empresa;
   * 7 - Associação;
   * 8 - Escola;
   * 9 - Grupo de Amigos;
   * 10 - Treinador;
   * 11 - Simpatizante;
   *
   * @private
   * @property profileType
   * @type Number
   */
  var profileType;

  /**
   * Carrega o conteúdo das tabs do perfil quando necessário.
   *
   * @private
   * @method laodTab
   * @param String tab ...
   */
  function laodTab(tab) {

    /**
     * O id do elemento que será o container do conteúdo a ser carregado.
     *
     * @private
     * @property target
     * @type String
     */
    var target;

    /**
     * A String que seleciona a url e o elemento a ser carregado.
     *
     * @private
     * @property loadContent
     * @type String
     */
    var loadContent;

    /**
     * A url que vai ser mudada pelo pushState().
     *
     * @private
     * @property url
     * @type String
     */
    var url;

    /**
     * O Objeto que é associado com a nova entrada de histórico criada pelo
     * pushState().
     *
     * @private
     * @property stateObj
     * @type Object
     */
    var stateObj;

    target = $('#' + tab + '> a').attr('href');
    loadContent = controllerName + '/' + tab + '/' + currentParam + ' #profile-' + tab;

    if(!$(target)[0].children.length > 0) {

      //adiciona o loader da tab
      $('.tab-content').append('<div id="tab-loader" style="width:64px; margin:0 auto;"><img src="./images/loader-spinning-black.svg" alt="Loading icon"></div>');

      //console.log('target: ' + target + ' - load( ' + loadContent + ' )');
      $(target).load( loadContent, function( response, status, xhr ) {

        //remove o loader da tab
        $('#tab-loader').remove();

        if ( status == "error" ) {
          console.log('profile.js : function laodTab - Error: ' + xhr.status + ' ' + xhr.statusText);
        } else {
          
          switch(tab) {
            case 'inicio':
              
              //se o tipo de perfil for de tenista, treinador ou simpatizante
              if(profileType === 0 || profileType === 10 || profileType === 11) {

                timelineMoments($('.time'));

                //carrega as estatísticas de desempenho.
                loadStats();
              }
              break;
            case 'rankings':

              //se o tipo de perfil for de tenista, treinador ou simpatizante
              if(profileType === 0 || profileType === 10 || profileType === 11) {
                //carrega os rankings
                loadRankings();
              }
              break;
            case 'programa':
              $('.panel-prog .ttip').tooltip();
              break;
          }
        }
      });
    }
  }

  /**
   * ...
   *
   * @private
   * @method timelineMoments
   */
  function timelineMoments(jqObject) {
    jqObject.each(function( index ) {
      var content = $(this).html();
      $(this).html(moment.unix(content).fromNow());
    });
  }

  /**
   * Carrega o conteúdo do box de Desempenho.
   *
   * @private
   * @method loadStats
   */
  function loadStats() {
    var jqxhr = $.ajax({
      type:'POST',
      url: $('.stats-box').data('url'),
      data: { id: $('.stats-box').data('id') }
    })
    .done(onLoadStatsSuccess)
    .fail(onLoadStatsFail);
  }

  /**
   * Callback de sucesso da chamada do método loadStats.
   *
   * @private
   * @method onLoadStatsSuccess
   * @param {Object} data Um Objeto JSON retornado do servidor.
   */
  function onLoadStatsSuccess(data) {
    $('.loader').removeClass('fadeIn').addClass('fadeOut').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
      $(this).css('display', 'none');

      console.log(data);

      //Se há dados de desempenho a exibir...
      if(data.hasData == 1) {
        console.log('hasData é 1!');
        var chartData = [{
          label: languages_translate.java_message_004,
          data: [],
          clickable: true
        }];
        
        for (var i = 0, max = data.lastFive.length; i < max; i++) {
          var performance = (data.lastFive[i].vitorias / (Number(data.lastFive[i].vitorias) + Number(data.lastFive[i].derrotas))) * 100;
          performance = (!isNaN(performance))? performance : 0;

          var jogos = Number(data.lastFive[i].vitorias) + Number(data.lastFive[i].derrotas);
          console.log('jogos: '+jogos);

          chartData[0].data.push([
            data.lastFive[i].ano,           //x
            performance.toFixed(2),         //y
            jogos,                          //e2
            data.lastFive[i].vitorias,      //e3
            data.lastFive[i].derrotas,      //e4
            data.lastFive[i].setvitorias,   //e5
            data.lastFive[i].setderrotas,   //e6
            data.lastFive[i].gamevitorias,  //e7
            data.lastFive[i].gamederrotas   //e8
          ]);
        }

        var template = _.template( $('#stats-template').html());
        var lastYearPerformance = chartData[0].data[0][1];
        var lastYearData = {
          texto: languages_translate.java_message_008,
          ano: data.lastFive[0].ano,
          performance: lastYearPerformance,
          jogos: Number(data.lastFive[0].vitorias) + Number(data.lastFive[0].derrotas),
          vitorias: data.lastFive[0].vitorias,
          derrotas: data.lastFive[0].derrotas,
          setvitorias: data.lastFive[0].setvitorias,
          setsaldo: Number(data.lastFive[0].setvitorias) - Number(data.lastFive[0].setderrotas),
          gamevitorias: data.lastFive[0].gamevitorias,
          gamesaldo: Number(data.lastFive[0].gamevitorias) - Number(data.lastFive[0].gamederrotas)
        };

        var totalPerformance = (data.total.vitorias / (Number(data.total.vitorias) + Number(data.total.derrotas))) * 100;
        totalPerformance = (!isNaN(totalPerformance))? totalPerformance : 0;
        var totalData = {
          texto: languages_translate.java_message_005,
          ano: '',
          performance: totalPerformance.toFixed(2),
          jogos: Number(data.total.vitorias) + Number(data.total.derrotas),
          vitorias: data.total.vitorias,
          derrotas: data.total.derrotas,
          setvitorias: data.total.setvitorias,
          setsaldo: Number(data.total.setvitorias) - Number(data.total.setderrotas),
          gamevitorias: data.total.gamevitorias,
          gamesaldo: Number(data.total.gamevitorias) - Number(data.total.gamederrotas)
        };

        $('.stats .col-xs-6:first-child').html( template( lastYearData ) );

        $('.stats .col-xs-6:last-child').html( template( totalData ) );

        $('.stats').css('display', 'block');

        console.log('pre-chart...');
        // Init Chart
        $('#chart1').pixelPlot( chartData, {
          series: { points: { show: true }, lines: { show: true } },
          xaxis: { tickDecimals: 0 },
          yaxis: { tickSize: 10, min: 0, max: 100, tickFormatter: graphYaxisLabelFormatter }
        }, {
          height: 300,
          tooltipText: languages_translate.java_message_003
        });
        console.log('pos-chart...');
      } else {
        console.log('hasData é diferente de 1!');
        $('.no-stats .col-xs-12').append( languages_translate.java_message_001 );
        $('.no-stats').css('display', 'block');
      }
    });
  }

  /**
   * Callback de falha da chamada do método loadStats.
   *
   * @private
   * @method onLoadStatsFail
   * @param {Object} jqXHR ...
   * @param {Object} textStatus ...
   */
  function onLoadStatsFail(jqXHR, textStatus) {
    console.log(jqXHR);
    console.log('onLoadStatsFail - Request failed: ' + textStatus);
  }

  /**
   * Formata a string das linhas horizontais do gráfico de Desempenho com
   * o símbolo de porcentagem.
   *
   * @private
   * @method graphYaxisLabelFormatter
   * @param Number val ...
   * @param {Object} axis ...
   */
  function graphYaxisLabelFormatter(val, axis) {
    return val + '%';
  }

  /**
   * ...
   *
   * @private
   * @method loadRankings
   */
  function loadRankings() {

    $('.ranking').each(function( index ) {
      var currentItem = $(this);

      var jqxhr = $.ajax({
        type:'POST',
        url: $(this).data('url'),
        data: {
          idtenista: $(this).data('id-tenista'),
          idranking: $(this).data('id-ranking'),
          idcategoria: $(this).data('id-categoria'),
          modelo: $(this).data('modelo-ranking')
        }
      })
      .done(function(data, textStatus, jqXHR) {

        var chartData = [{
          label: languages_translate.posicao,
          data: [],
          clickable: true
        }];
          
        for (var i = 0, max = data.slices.length; i < max; i++) {
          chartData[0].data.push([
            data.slices[i].timestamp,                                   //x
            data.slices[i].pos,                                         //y
            data.slices[i].pontos,                                      //e2
            moment.unix(data.slices[i].timestamp).format("DD/MM/YYYY")  //e3
          ]);
        }

        // Init Chart
        $('#chart-'+ currentItem.data('id-ranking') +'-' + currentItem.data('id-categoria')).pixelPlot( chartData, {
          series: { points: { show: true }, lines: { show: true } },
          xaxis: {
            mode: "time",
            monthNames: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
            timeformat: "%b", //"%d/%m",
            minTickSize: [1, "month"] //[7, "days"]
          },
          yaxis: {
            tickDecimals: 0,
            transform: function (v) { return -v; },
            inverseTransform: function (v) { return -v; }
          }
        }, {
          height: 300,
          tooltipText: languages_translate.java_message_006
        });
      })
      .fail(onLoadRankingFail);
    });
  }

  /**
   * Callback de falha da chamada do método loadRankings.
   *
   * @private
   * @method onLoadRankingFail
   * @param {Object} jqXHR ...
   * @param {Object} textStatus ...
   */
  function onLoadRankingFail(jqXHR, textStatus) {
    console.log(jqXHR);
    console.log('onLoadRankingSuccess - Request failed: ' + textStatus);
  }

  /**
   * Inicia o módulo.
   *
   * @private
   * @method init
   */
  function init() {

    //QJT-TODO: Corrigir Histórico do browser que não funciona direito com os botões de "back" e "Forward"
    pathArray = window.location.pathname.split('/');
    basePathIndex = pathArray.indexOf(controllerName);

    profileType = $('.profile-container').data('profile-type');

    //se existe o controllerName na url
    if(basePathIndex != -1) {

      currentMethod = pathArray[basePathIndex + 1];
      currentParam = pathArray[basePathIndex + 2];

      if(currentMethod !== undefined && currentParam !== undefined) {

        // Store the initial content so we can revisit it later
        window.history.replaceState({ method: currentMethod }, '', controllerName + '/' + currentMethod + '/' + currentParam);

        //se o tipo de perfil for de tenista, treinador ou simpatizante
        if(profileType === 0 || profileType === 10 || profileType === 11) {
          
        } else {
          $('#btn-contato').click( function(e) {
            e.preventDefault();
            $('.tab a[href="#profile-tabs-contato"]').tab('show'); // Select tab by name
          });
        }

        switch(currentMethod) {
          case 'inicio':
            //se o tipo de perfil for de tenista, treinador ou simpatizante
            if(profileType === 0 || profileType === 10 || profileType === 11) {

              timelineMoments($('.time'));

              //carrega as estatísticas de desempenho.
              loadStats();
            } else {
              timelineMoments($('.moment'));
            }
            break;
          case 'rankings':
            //se o tipo de perfil for de tenista, treinador ou simpatizante
            if(profileType === 0 || profileType === 10 || profileType === 11) {
              //carrega os rankings
              loadRankings();
            }
            break;
        }

      } else {
        console.log('método ou parâmetro indefinido na url.');
      }
    } else {
      console.log('Nome da controller não aparece na url');
    }

    window.onpopstate = function(event) {
      console.log('state: ' + JSON.stringify(event.state));

      if(event.state != null) {
        $('#profile-tabs #' + event.state.method + ' > a').tab('show');
      }

      //console.log(event.state.method);
      //console.log(event.state.url);
      
    };

    $('#profile-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      currentMethod = $(e.target).parent().attr('id');

      //QJT-TODO: Arrumar o history.back do navegador.

      window.history.pushState({method: currentMethod}, '', controllerName + '/' + currentMethod + '/' + currentParam);
      laodTab(currentMethod);
    });

  }

  //inicia o módulo quando carregado.
  init();

  return {

  }

})(jQuery);